const reactTInit = () => {
  if (typeof Drupal !== 'undefined') {
    /*global Drupal:true*/
    Drupal.t('Site name');
    Drupal.t('Type');
    Drupal.t('Search');
    Drupal.t('Keywords');
    Drupal.t('Collections');
    Drupal.t('Citation');
    Drupal.t('Share');
    Drupal.t('Download');
    Drupal.t('Add this document to your bookmarks.');
    Drupal.t('Remove this document from your bookmarks.');
    Drupal.t('Bookmark');
    Drupal.t('Unbookmark');
    Drupal.t('Publication date');
    Drupal.t('Internal document');
    Drupal.t('Copy to Clipboard');
    Drupal.t('Country');
    Drupal.t('Document source');
    Drupal.t('Document source classifications');
    Drupal.t('Publisher');
    Drupal.t('Publisher category');
    Drupal.t('Country classifications');
    Drupal.t('Judicial body');
    Drupal.t('Region');
    Drupal.t('Languages');
    Drupal.t('Legal instruments');
    Drupal.t('Populations groups');
    Drupal.t('Religious groups');
    Drupal.t('Persons of concern');
    Drupal.t('Document type');
    Drupal.t('Date');
    Drupal.t('Showing @count results for');
    Drupal.t('Sorry, your search yielded no results.');
    Drupal.t('Sort By');
    Drupal.t('Search tips');
    Drupal.t('Sort by');
    Drupal.t('Date (newest - oldest)');
    Drupal.t('Date (oldest - newest)');
    Drupal.t('Relevance');
    Drupal.t('Title (A-Z)');
    Drupal.t('Title (Z-A)');
    Drupal.t('Reset all filters');
    Drupal.t('Search in full text');
    Drupal.t('View with description');
    Drupal.t('Filters');
    Drupal.t('Start Date');
    Drupal.t('End Date');
    Drupal.t('From Date');
    Drupal.t('To Date');
    Drupal.t('Last 3 months');
    Drupal.t('Last 1 year');
    Drupal.t('Last 3 years');
    Drupal.t('There are no results to filter.');
    Drupal.t('First');
    Drupal.t('Previous');
    Drupal.t('Next');
    Drupal.t('Last');
    Drupal.t('accessed ');
    Drupal.t('What are you looking for?');
    Drupal.t('Visit link');
    Drupal.t('Press <code>ENTER</code> to search for <strong>@value</strong> or <code>ESC</code> to close.');
    Drupal.t('Press keyboard arrows <code>UP</code> or <code>DOWN</code> to highlight a suggestion then <code>ENTER</code> to be redirected to that suggestion.');
    Drupal.t('Clear');
    Drupal.t('Apply');
    Drupal.t('No results found.');
    Drupal.t('Show all in');
    Drupal.t('Show all');
    Drupal.t('Clear selection');
    Drupal.t('Search in');
    Drupal.t('Countries');
    Drupal.t('Document sources');
    Drupal.t('Document types');
    Drupal.t('Judicial bodies');
    Drupal.t('Country of asylum');
    Drupal.t('Country of origin');
    Drupal.t('Country of transit');
    Drupal.t('You have selected the maximum number of filters for this search. Please deselect one or more filters to continue.');
  }
};

export default reactTInit;
